<template>
  <div>
    <div class="stps">
      <div class="stps-item" v-for="(item, index) in list" :key="index">

        <div v-if="index == 0">
          <div class="circular-out">
            <div class="circular-in"></div>
          </div>
          <div class="line" v-if="index + 1 !== list.length"></div>
        </div>

        <div v-else>
          <div class="circular-out-noactive">
            <div class="circular-in"></div>
          </div>
          <div class="line b-l-c" v-if="index + 1 !== list.length"></div>
        </div>

        <span class="time" :class="{'cl-0':!index}">{{ item.createTime }}</span>
        <div class="stps-container">
          <div class="img-tag">
            <img v-if="item.picture" :src="item.picture" />
            <img v-if="!item.picture && item.type == 4" src="@/assets/images/icon/org/cart.png" />
            <img v-if="!item.picture && item.type == 5" src="@/assets/images/icon/org/report.png" />
            <img v-if="!item.picture && item.type == 2" src="@/assets/images/icon/org/prospectus.png" />
            <div class="tag">{{ setType(item.type) }}</div>
          </div>
          <div class="describe">
            <span>{{ item.title }}</span>
            <span v-if="item.visiteTime"
              >阅读{{ formatSeconds(item.visiteTime) }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <no-data v-if="!list.length"></no-data>
  </div>
</template>

<script>
export default {
  name: "detailAccessDynamic",
  props: ["id"],
  data() {
    return {
      list: [],
      typeList:[]
    };
  },
  created() {
    this.getType();
    this.getInsureList();
  },
  methods: {
    getInsureList() {
      this.$http({
        url: "/buz/customerBase/read/accesstrack/list",
        type: "POST",
        data: {
          customerId: this.id,
        },
      }).then((res) => {
        this.list = res.data;
      });
    },

    getType() {
      this.$http({
        url: "/system/dic/read/dicList",
        type: "POST",
        data: {
          code: "VISIT_TYPE"
        },
      }).then((res) => {
        this.typeList = res.data;
      });
    },

    setType(value) {
      let str = '';
      this.typeList.map(item=>{
        if(item.value == value){
          str = item.txt;
        }
      })
      return str;
    },

    //秒数转化为时分秒
    formatSeconds(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取余，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60);
          //获取小时后取余的分，获取分钟除以60取余的分
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      var result = "" + parseInt(secondTime) + "秒";

      if (minuteTime > 0) {
        result = "" + parseInt(minuteTime) + "分" + result;
      }
      if (hourTime > 0) {
        result = "" + parseInt(hourTime) + "小时" + result;
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.stps {
  .stps-item {
    position: relative;
    display: flex;
    flex-direction: column;
    padding-left: 15px;
    padding-bottom: 35px;

    .circular-out {
      position: absolute;
      top: 3px;
      left: -6px;
      width: 11px;
      height: 11px;
      border: 1px solid #236dff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      .circular-in {
        width: 7px;
        height: 7px;
        background: #236dff;
        border-radius: 50%;
      }
    }
    .circular-out-noactive {
      position: absolute;
      top: 3px;
      left: -6px;
      width: 11px;
      height: 11px;
      background-color: #f7f7f7;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      .circular-in {
        width: 7px;
        height: 7px;
        background: #d4d5d8;
        border-radius: 50%;
      }
    }
    .line {
      width: 1px;
      height: 110px;
      border-left: 1px dashed #236dff;
      position: absolute;
      left: -1px;
      top: 18px;
    }
    & .b-l-c {
      border-left: 1px dashed #D4D5D8 !important;
    }
    .time {
      font-size: 12px;
      color: #727C8E;;
    }
    & .cl-0 {
      color: #236dff;
    }
    .stps-container {
      margin-top: 10px;
      display: flex;
      .img-tag {
        position: relative;
        img {
          width: 68px;
          height: 68px;
          border-radius: 2px;
          margin-right: 20px;
        }
        .tag {
          font-size: 12px;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          bottom: 0px;
          width: 68px;
          height: 18px;
          background: #CECECE;
        }
      }
      .describe {
        justify-content: center;
        display: flex;
        flex-direction: column;
        span:first-child {
          margin-bottom: 14px;
          color: #515c6f;
          font-size: 12px;
        }
        span:last-child {
          color: #727c8e;
          font-size: 12px;
        }
      }
    }
  }
}
</style>